import React from "react";
import busy from "lib/busy";

export default class LoadingScreen extends React.Component {
  componentWillMount() {
    this.clear = busy(null, { immediate: this.props.immediate !== false });
  }

  componentWillUnmount() {
    if (this.clear) this.clear();
  }

  render() {
    return <span />;
  }
}
